import React from 'react'
import classNames from 'classnames'

import style from './style.scss'

type Props = {
  className?: string
  kind?: 'black' | 'white' | 'red' | 'blue' | 'gray' | 'thin-light-gray'
  small?: boolean
}

function Ruler(props: Props) {
  const { className, small = false, kind = 'black' } = props

  return (
    <hr
      aria-hidden
      className={classNames(style.wrapper, className, style[kind], {
        [style.small]: small,
      })}
      data-testid='ruler'
    />
  )
}

export default Ruler
